
import { defineComponent } from 'vue';
import VueElementLoading from 'vue-element-loading';

export default defineComponent({
    name: 'LoadingSpinner',
    components: {
        VueElementLoading,
    },
    props: {
        size: {
            Type: Number,
            default: 100,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
});
